import React,{useEffect} from 'react'
import hljs from 'highlight.js';
import SidebarInf03 from '../../components/sidebar/SidebarInf03';


const Crudphpxampp = () => {
  
    useEffect(() => {
        hljs.addPlugin({
            'after:highlightElement': ({ result, el }) => {
                const lines = document.createElement('div');
                if (!result.value.includes('<span class="line-num">')) {
                    lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
                }
                el.replaceChildren(...lines.childNodes);
            }
        });
    
    
        if (!document.querySelector('.hljs')) {
          hljs.highlightAll();
      }
       
      });

    
      return (
        <div id='rozwiazaniainf03'>
    
        <SidebarInf03></SidebarInf03>
    
            <div id="rozwiazanieustawienie">
              <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
                <h1>Operacje CRUD w PHP i MySQL (XAMPP)</h1>
                <section>
                  <hr></hr>
                  <h2>Wprowadzenie</h2>
                  <blockquote class="introduction">
                    <strong>Zanim zaczniemy...</strong>
                    <b>CRUD</b> to skrót oznaczający cztery podstawowe operacje wykonywane na danych w bazie danych:
                     <b>Create</b> (tworzenie), <b>Read</b> (odczytywanie), <b>Update</b> (aktualizowanie) i <b>Delete</b> (usuwanie). 
                    W tym artykule pokażemy, jak zaimplementować te operacje w PHP, korzystając z bazy danych MySQL na serwerze XAMPP..
                  </blockquote>
                  <hr></hr>
                  <h2>Krok 1: Tworzenie bazy danych i tabeli</h2>
                  <p>
    Aby stworzyć bazę danych i tabelę, otwórz przeglądarkę i przejdź do <code>http://localhost/phpmyadmin</code> (Pamiętaj pierw o uruchomieniu usług Apache i MySql). Następnie utwórz nową bazę danych o nazwie <code>crud_db</code>. Następnie utwórz tabelę <code>users</code> z następującymi kolumnami:
                    </p>
                    <ul>
                        <li><code>id</code> (INT, AUTO_INCREMENT, PRIMARY KEY)</li>
                        <li><code>username</code> (VARCHAR(50))</li>
                        <li><code>email</code> (VARCHAR(50))</li>
                        <li><code>password</code> (VARCHAR(50))</li>
                    </ul>
                    <p>Oto zapytanie SQL tworzące tę tabelę:</p>
                    <pre>
                        <code>
                    {`CREATE DATABASE crud_db;
USE crud_db; -- przełączenie do bazy danych można to ręcznie zrobić
CREATE TABLE users (
    id INT AUTO_INCREMENT PRIMARY KEY, -- Klucz główny
    username VARCHAR(50) NOT NULL, 
    email VARCHAR(50) NOT NULL, 
    password VARCHAR(50) NOT NULL
);`}
                        </code>
                    </pre>
                  <hr></hr>
                </section>
                <section>
                <h2>Krok 2: Połączenie z bazą danych w PHP</h2>
<p>
    Stwórz plik PHP <code>db.php</code>, który będzie zawierał kod do połączenia z bazą danych:
</p>
<pre>
    <code>
{`<?php
$servername = "localhost";
$username = "root";
$password = "";
$dbname = "crud_db";

// Tworzenie połączenia
$conn = mysqli_connect($servername, $username, $password, $dbname);

// Sprawdzanie połączenia
if (!$conn) {
    die("Connection failed: " . mysqli_connect_error());
}
?>`}
    </code>
</pre>
                </section>
                <hr></hr>
                <section>
                <h2>Krok 3: Tworzenie (Create)</h2>
<p>
    Stwórz plik PHP <code>create.php</code>, który będzie zawierał formularz do dodawania nowych użytkowników oraz kod do obsługi tego formularza:
</p>

<h3>Formularz HTML</h3>
<pre>
    <code>
{`<!DOCTYPE html>
<html lang="pl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Dodaj Użytkownika</title>
</head>
<body>
    <h2>Dodaj Użytkownika</h2>
    <form action="create.php" method="post">
        <label for="username">Nazwa użytkownika:</label>
        <input type="text" id="username" name="username" required><br><br>
        <label for="email">Email:</label>
        <input type="email" id="email" name="email" required><br><br>
        <label for="password">Hasło:</label>
        <input type="password" id="password" name="password" required><br><br>
        <input type="submit" value="Dodaj">
    </form>
</body>
</html>`}
    </code>
</pre>

<h3>Obsługa formularza</h3>
<p>Dodaj poniższy kod PHP na początku pliku <code>create.php</code>, przed deklaracją HTML:</p>
<pre>
    <code>
{`<?php
require 'db.php';

if ($_SERVER["REQUEST_METHOD"] == "POST") {
    $username = $_POST['username'];
    $email = $_POST['email'];
    $password = $_POST['password'];

    $sql = "INSERT INTO users (username, email, password) VALUES ('$username', '$email', '$password')";

    if (mysqli_query($conn, $sql)) {
        echo "Nowy użytkownik został dodany.";
    } else {
        echo "Błąd: " . $sql . "<br>" . mysqli_error($conn);
    }

    mysqli_close($conn);
}
?>`}
    </code>
</pre>
                </section>
<hr></hr>
<section>
<h2>Krok 3: Odczytywanie (Read)</h2>
<p>
    Stwórz plik PHP <code>read.php</code>, który wyświetli listę użytkowników w tabeli HTML:
</p>
<pre>
    <code>
{`<?php
require 'db.php';

$sql = "SELECT * FROM users";
$result = mysqli_query($conn, $sql);
?>

<!DOCTYPE html>
<html lang="pl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Lista Użytkowników</title>
</head>
<body>
    <h2>Lista Użytkowników</h2>
    <table border="1">
        <tr>
            <th>ID</th>
            <th>Nazwa użytkownika</th>
            <th>Email</th>
            <th>Hasło</th>
            <th>Akcje</th>
        </tr>
        <?php
        if (mysqli_num_rows($result) > 0) {
            while($row = mysqli_fetch_assoc($result)) {
                echo "<tr>";
                echo "<td>" . $row['id'] . "</td>";
                echo "<td>" . $row['username'] . "</td>";
                echo "<td>" . $row['email'] . "</td>";
                echo "<td>" . $row['password'] . "</td>";
                echo "<td>
                        <a href='update.php?id=" . $row['id'] . "'>Edytuj</a>
                        <a href='delete.php?id=" . $row['id'] . "'>Usuń</a>
                      </td>";
                echo "</tr>";
            }
        } else {
            echo "<tr><td colspan='5'>Brak użytkowników</td></tr>";
        }
        ?>
    </table>
</body>
</html>

<?php
mysqli_close($conn);
?>`}
    </code>
</pre>
</section>
<hr></hr>
<section>
<h2>Krok 4: Aktualizowanie (Update)</h2>
<p>
    Stwórz plik PHP <code>update.php</code>, który umożliwi edytowanie danych użytkownika:
</p>

<h3>Formularz HTML z danymi użytkownika</h3>
<pre>
    <code>
{`<?php
require 'db.php';

$id = $_GET['id'];
$sql = "SELECT * FROM users WHERE id=$id";
$result = mysqli_query($conn, $sql);
$row = mysqli_fetch_assoc($result);
?>

<!DOCTYPE html>
<html lang="pl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Edytuj Użytkownika</title>
</head>
<body>
    <h2>Edytuj Użytkownika</h2>
    <form action="update.php" method="post">
        <input type="hidden" name="id" value="<?php echo $row['id']; ?>">
        <label for="username">Nazwa użytkownika:</label>
        <input type="text" id="username" name="username" value="<?php echo $row['username']; ?>" required><br><br>
        <label for="email">Email:</label>
        <input type="email" id="email" name="email" value="<?php echo $row['email']; ?>" required><br><br>
        <label for="password">Hasło:</label>
        <input type="password" id="password" name="password" value="<?php echo $row['password']; ?>" required><br><br>
        <input type="submit" value="Zapisz">
    </form>
</body>
</html>

<?php
mysqli_close($conn);
?>`}
    </code>
</pre>

<h3>Obsługa aktualizacji</h3>
<p>Dodaj poniższy kod PHP na początku pliku <code>update.php</code>, przed deklaracją HTML:</p>
<pre>
    <code>
{`<?php
require 'db.php';

if ($_SERVER["REQUEST_METHOD"] == "POST") {
    $id = $_POST['id'];
    $username = $_POST['username'];
    $email = $_POST['email'];
    $password = $_POST['password'];

    $sql = "UPDATE users SET username='$username', email='$email', password='$password' WHERE id=$id";

    if (mysqli_query($conn, $sql)) {
        echo "Dane użytkownika zostały zaktualizowane.";
    } else {
        echo "Błąd: " . $sql . "<br>" . mysqli_error($conn);
    }

    mysqli_close($conn);
}
?>`}
    </code>
</pre>
</section>
<hr></hr>
<section>
<h2>Krok 7: Usuwanie (Delete)</h2>
<p>
    Stwórz plik PHP <code>delete.php</code>, który usunie użytkownika z bazy danych:
</p>
<pre>
    <code>
{`?php
require 'db.php';

$id = $_GET['id'];
$sql = "DELETE FROM users WHERE id=$id";

if (mysqli_query($conn, $sql)) {
    echo "Użytkownik został usunięty.";
} else {
    echo "Błąd: " . $sql . "<br>" . mysqli_error($conn);
}

mysqli_close($conn);
header("Location: read.php");
exit();
?>`}
    </code>
</pre>

<h2>Podsumowanie</h2>

</section>


    <blockquote className="info">
        <strong>Co się dowiedziałeś?</strong>
        W tym artykule omówiliśmy podstawowe operacje CRUD (Create, Read, Update, Delete) w PHP, korzystając z bazy danych MySQL na serwerze XAMPP. Tworzenie, odczytywanie, aktualizowanie i usuwanie danych to podstawowe umiejętności niezbędne do zarządzania bazą danych w aplikacjach webowych. Dzięki temu tutorialowi jesteś w stanie stworzyć prostą aplikację zarządzania użytkownikami, która może być podstawą bardziej zaawansowanych projektów.
    </blockquote>
    
              </div>
              
            </div>
        </div>
      )
}

export default Crudphpxampp